// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageImageError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 28C29.6495 28 32 25.6495 32 22.75C32 19.8505 29.6495 17.5 26.75 17.5C23.8505 17.5 21.5 19.8505 21.5 22.75C21.5 25.6495 23.8505 28 26.75 28ZM24.875 19.75L23.75 20.875L25.625 22.75L23.75 24.625L24.875 25.75L26.75 23.875L28.625 25.75L29.75 24.625L27.875 22.75L29.75 20.875L28.625 19.75L26.75 21.625L24.875 19.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.875 19.75L23.75 20.875L25.625 22.75L23.75 24.625L24.875 25.75L26.75 23.875L28.625 25.75L29.75 24.625L27.875 22.75L29.75 20.875L28.625 19.75L26.75 21.625L24.875 19.75Z" class="svg-fg"/>
  <path d="M30 0H0V24H19.6074C19.5368 23.5939 19.5 23.1763 19.5 22.75C19.5 20.2435 20.772 18.0341 22.7056 16.732L20 14L16 18L10 9L2 21V2H28V15.6074C28.7071 15.7302 29.3791 15.9556 30 16.2675V0Z" class="svg-bg"/>
  <path d="M26 7C26 8.65685 24.6569 10 23 10C21.3431 10 20 8.65685 20 7C20 5.34315 21.3431 4 23 4C24.6569 4 26 5.34315 26 7Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageImageError is a generated icon component.
 */
let IconImageImageError = IconImageImageError_1 = class IconImageImageError extends IconBaseElement {
    render() {
        return html `${IconImageImageError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageImageError.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconImageImageError = IconImageImageError_1 = __decorate([
    customElement('zui-icon-image-image-error')
], IconImageImageError);
export { IconImageImageError };
